import dayjs from 'dayjs'

export const getFormattedDate = (date: string) => {
  return dayjs(date).format('YYYY/MM/DD').toString()
}